import React from 'react';
import {FormSelect} from '@goproblems/ui';
import {useTheme} from '@components/theme/useTheme';

type Option = {
    label: string;
    value: string | number;
};

type CustomSelectProps = {
    options: Option[];
    selectedValue?: string | number;
    onSelect?: (option: Option) => void;
    size?: 'sm' | 'lg';
    allowEmpty?: boolean;
    emptyLabel?: string;
};

export const CustomSelect: React.FC<CustomSelectProps> = ({
    options,
    selectedValue,
    onSelect,
    size = 'sm',
    allowEmpty,
    emptyLabel = '-- Please select --',
}) => {
    const theme: 'light' | 'dark' = useTheme();
    return (
        <div data-theme={theme}>
            <FormSelect
                size={size}
                value={selectedValue}
                onChange={e => {
                    const val = e.target.value;

                    if (val === '') {
                        onSelect?.({label: emptyLabel, value: ''});
                        return;
                    }

                    const selectedOption = options.find(
                        option => String(option.value) === val
                    );
                    if (selectedOption) {
                        onSelect?.(selectedOption);
                    }
                }}>
                {allowEmpty && <option value="">{emptyLabel}</option>}
                {options.map(option => (
                    <option key={option.label} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </FormSelect>
        </div>
    );
};
